import { useEffect, useState } from "react";
import { Button, Card, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, Table } from "reactstrap"
import ApiService from "../../services/apiService";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import { method } from "lodash";
import { toast } from "react-toastify";
import { format } from "date-fns/format";
import DeleteIcon from "../svg/DeleteIcon";

interface retrys {
   chakId:string|number;
   valveNumber:string|number;
   schedulerNumber:string|number;
   enable_Disable:boolean;
   startDate:number|string;
   endDate:number|string;
   startTime:Date;
   duration:number|string;
   weekdays:number|string;
   _uid:string|number
}

interface deviceCommand {
     _uid:string|number
      deviceId:string|number;
      status:0;
      command:string
}

const ScheduleStatus =() =>{

     const [nodeScheduler,setNodeScheduler]= useState<any[]>()
     const [secondDropdown, setSecondDropdown] = useState(false);
     const [groupData, setGroupData] = useState<any[]>([]);
     const [collapsed, setCollapsed] = useState(false);
     const [selectedGroup, setSelectedGroup] = useState<string>("");
     const [selectedGroupId, setSelectedGroupId] = useState<number | string>();
     const [deviceType, setDeviceType] = useState<string>("");
     const [selectedRetry,setSelectedRetry] = useState<deviceCommand[]>([])
     const [selectedErase,setSelectedErase] = useState<deviceCommand[]>([])

     let pollingInterval: NodeJS.Timeout | null = null;
     let pollingTimeout: NodeJS.Timeout | null = null;
     
     type ProgressMode = "RETRY" | "DELETE";
     let currentProgressMode: ProgressMode | null = null;

     const POLLING_INTERVAL = 5000;
     const TICK = 500;
     const POLLING_DURATION = 25_000; // 25 seconds
      // update every 250ms (smooth)
     let retryToastId: any = null;
     let progressInterval: any = null;
     let startTime = 0;
     
     const toggleDropdown2 = () => setSecondDropdown(!secondDropdown);

     const getGroupNameForDropdown = async () => {
          try {
            const response = await ApiService.axiosApi(
              `/group`,
              {
                method: "GET",
                params: { pageNumber: 0, pageSize: 0 },
              }
            );
            if (response.success) {
              setGroupData(response.data.data);
              console.log(response.data.data);
            }
          } catch (e) {
            console.log(e);
          }
        };
       
        useEffect(()=>{
            getGroupNameForDropdown();
        },[])

     const getNodeScheduler = async () => {
          try {
            const response = await ApiService.axiosApi(
              `/schedulestatus/${selectedGroupId}`,
              {
                method: "GET",
                params:{
                   pageNumber:0,
                   pageSize:0
                }
              }
            );
            if (response.success) {
               const result = response.data.data.map((item:any,i:any) => ({
                     ...item,
                     _uid: i + 1
               }))
              setNodeScheduler(result);
            } else {
              console.log("Unable to get node Schedule");
            }
          } catch (e) {
            console.log(e);
          }
        };

        useEffect(()=>{
           getNodeScheduler()
        },[selectedGroupId])
          


        const startSchedulerCheck = () => {
          const interval = setInterval(() => {
            getNodeScheduler();
          }, 5000); // run every 5 seconds
        
          // Stop after 25 seconds
          setTimeout(() => {
            clearInterval(interval);
            setSelectedRetry([])
          }, 25000);
        };
           
        const deleteSchedule = async (deviceId: number, command: string) => {
          try {
            currentProgressMode = "DELETE";
            retryToastId = toast.loading("Deleting schedule...", {
              closeOnClick: false,
              draggable: false,
            });

            
            const response = await ApiService.axiosApi(`/qcommand`, {
              method: "POST",
              data: { deviceId, command }
            });
        
            if (response.success) {
              startProgressBar();
              startCheckingPolling(deviceId,command);
            } else {
              toast.error("Not succeeded");
            }
          } catch (e) {
            console.log(e);
          }
        };
        
    
         
        const checkScheduleErase = async (deviceId: number,command:string) => {
          try {
            const response = await ApiService.axiosApi(`/qcommand`, {
              method: "GET",
              params: {
                deviceId,
                command:command
              }
            });
        
            if (response.success && response.data?.status === 1) {
              toast.success("Schedule erased successfully");
              stopAllPolling();
               getNodeScheduler();
              setSelectedRetry([]);
            }
          } catch (e) {
            console.log(e);
          }
        };
        

        const startCheckingPolling = (deviceId: number,command:string) => {
          // API polling every 5 sec
          pollingInterval = setInterval(() => {
            checkScheduleErase(deviceId,command);
          }, POLLING_INTERVAL);
        
          // Safety stop after 25 sec
          pollingTimeout = setTimeout(() => {
            stopAllPolling();
            setSelectedRetry([]);
          }, POLLING_DURATION);
        };
        
        



        const sendCommand = async() =>{
           try{
            currentProgressMode = "RETRY";
            retryToastId = toast.loading("Retry in progress...", {
              closeOnClick: false,
              draggable: false,
            });
        

                const response = await ApiService.axiosApi(`/qcommand/addbulk`,{
                     method:'POST',
                     data:selectedRetry
                });
                if(response.success){
                  startProgressBar();
                     startSchedulerCheck(); 
                }
           }catch(e){
               console.log(e)
          }
        }

        const startProgressBar = () => {
          startTime = Date.now();
        
          progressInterval = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / POLLING_DURATION, 1);
            let label = "";
            if (currentProgressMode === "RETRY") {
              label = `Retry in progress... ${Math.round(progress * 100)}%`;
            } else if (currentProgressMode === "DELETE") {
              label = `Deleting schedule... ${Math.round(progress * 100)}%`;
            }
            toast.update(retryToastId, {
              progress,
              render:label,
            });

           
        
            if (progress >= 1) {
              clearInterval(progressInterval!);
            }
          }, TICK);
        };
        
        const stopAllPolling = () => {
          if (pollingInterval) {
            clearInterval(pollingInterval);
            pollingInterval = null;
          }
        
          if (pollingTimeout) {
            clearTimeout(pollingTimeout);
            pollingTimeout = null;
          }
        
          if (progressInterval) {
            clearInterval(progressInterval);
            progressInterval = null;
          }
        
          toast.update(retryToastId, {
            render: "Retry completed",
            progress: 1,
            autoClose: 3000,
          });
        };
        

      

       
           console.log(selectedErase)

        
     return (
           <>
            <Breadcrumbs mainTitle="Schedule Status" parent="Schedule" />
      <Card className="p-2">
        <CommonCardHeader title="Schedule Status" headClass={"pb-3"} />
              <div
          className="p-3 d-flex mb-1 bg-light-primary justify-content-between"
          style={{
            cursor: "pointer",
            backgroundColor: "whitesmoke",
            borderRadius: "5px",
          }}
        >
          <div className="d-flex justify-content-start">
            <span>Schedules (10)</span>
            <span onClick={() => setCollapsed(!collapsed)}>
              {collapsed ? "▼" : " ▲"}
            </span>

           
          </div>

          <div className="report-input-div mx-4 input-border d-flex justify-content-end align-items-center"style={{width:'20%'}}>
          

            <Dropdown
              isOpen={secondDropdown}
              toggle={toggleDropdown2}
              style={{width:'50%'}}
            >
              <DropdownToggle
                className="custom-dropdown-toggle d-flex align-items-center justify-content-between report-dropdown"
                style={{
                    backgroundColor: "rgb(43, 95, 96)",
                    borderColor: "rgb(43, 95, 96)",
                    color: "#fff",
                    fontWeight: 500,
                    borderRadius: "5px",
                    padding: "8px 16px",
                    width:'100%',
                    height: "36px",
                }}
                color="whitesmoke"
              >
                {selectedGroup ? selectedGroup : "Group"}
              </DropdownToggle>
              <DropdownMenu style={{ overflowY: "auto", borderRadius: "8px" }}>
                {groupData?.map((data: any) => (
                  <DropdownItem
                    key={data.id}
                    onClick={() => {
                      setSelectedGroup(data.groupName);
                      setSelectedGroupId(data.groupId);
                      setDeviceType(data.deviceType);
                    }}
                  >
                    {data.groupName}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>

            <div style={{marginLeft:'3px'}}>
            <Button
                        color="primary"
                        size="md"
                       
                        onClick={() => sendCommand()}
                      >
                        Retry
                      </Button>
            </div>
          </div>
        </div>





        {!collapsed &&  <div className="table-responsive">
            <Table
              bordered
              hover
              responsive
              className="align-middle text-center"
            >
              <thead className="bg-light-primary">
                <tr>
                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    #
                  </th>


                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                     select for retrys
                  </th>


                  

                  

                 
                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Chak Name
                  </th>
                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Chak Area
                  </th>
                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Schedule No.
                  </th>
                 
                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                   Enable/Disable
                  </th>
                  
                  
                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Status
                  </th>

                  <th
                    style={{
                      fontWeight: 600,
                      color: "#333",
                      padding: "6px",
                      fontSize: "1rem",

                      height: "50px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Erase Schedule
                  </th>
                 
                </tr>
              </thead>
              <tbody>
                {nodeScheduler?.map((chak, index) => (
                  <tr key={chak._uid}>
                      

                    <td>{index + 1}</td>
                    <td>
                          <Input  
                             type="checkbox"
                              checked={selectedRetry.some(x => x._uid === chak._uid)}
                             onChange={()=>{
                              setSelectedRetry(prev => {
                                   const exists = prev.some(x => x._uid === chak._uid);
                                   
                                   if (exists) {
                                     return prev.filter(x => x._uid !== chak._uid);
                                   } else {
                                     return [
                                       ...prev,
                                       {
                                        _uid: chak._uid,
                                       deviceId:chak.chakId,
                                       command: `RSHH ${Number(chak.scheduleNo).toString(16).toUpperCase()} ${chak.enable ? 1 : 0} ${Number(chak.startDate).toString(16).toUpperCase()} ${Number(chak.endDate).toString(16).toUpperCase()} ${(
                                         (() => {
                                           const [hh, mm] = chak.startTime.split(":");
                                           return (Number(hh) * 60 + Number(mm));
                                         })()
                                       ).toString(16).toUpperCase()} ${Number(chak.duration).toString(16).toUpperCase()} ${Number(chak.volume).toString(16).toUpperCase()} ${Number(chak.weekDays).toString(16).toUpperCase()} ${Number(chak.valveNumber).toString(16).toUpperCase()}`
                                       ,
                                       status:0
                                  }
                                     ];
                                    }
                                })
                             }} 

                          />
                          
                      </td>

                     

                     

                    
                    <td>{chak.chakName}</td>
                    <td>{chak.chakArea}</td>
                    <td>{chak.scheduleNo}</td>
                    <td>{chak.enable?'enable':'disable'}</td>
                    
                    <td>
                      <span
                        className={`badge ${
                          chak.status === "Success"
                            ? "bg-success"
                            : chak.status === "Failed"
                            ? "bg-danger"
                            : "bg-warning text-dark"
                        }`}
                      >
                        {chak.status}
                      </span>
                    </td>
                    <td className="justify-content-center d-flex">
                    <Button
                       key={index}
                       color='primary'
                       onClick={()=>deleteSchedule(chak.chakId, `SCHER ${chak.scheduleNo} ${chak.scheduleNo}`)}
                       className={`main-button d-flex justify-content-center`}
                    >
                      <div style={{ width: '20px', height:'20px' }}>
                          <DeleteIcon />
                      </div>
                    </Button>                     
                    </td>
                    
                  </tr>
                ))}
              </tbody>
            </Table>
          </div> }
          </Card>
           </>
     )
}

export default ScheduleStatus;